require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-melbourne-house-rents-drop-in-affluent-suburbs-including.json") })
        }
      }, "path---news-melbourne-house-rents-drop-in-affluent-suburbs-including");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-melbourne-house-rents-drop-in-affluent-suburbs-including!./.cache/json/news-melbourne-house-rents-drop-in-affluent-suburbs-including.json
// module id = 830
// module chunks = 231608221292675